import {
  FAQ_FORM_LOADER_ACTIVE,
  FAQ_LOADER_ACTIVE,
  SET_FAQ_DATA,
  FAQ_FORM_SUBMITTED,
  SET_FAQ_SECTION_DATA,
  SET_SINGLE_FAQ_DATA,
  DOWNLOAD_COUNT,
} from "../actionTypes";

const initialState = {
  faqLoader: false,
  faqData: [],
  singleFaq: {},
  faqSectionData: {},
  faqFormLoader: false,
  formSubmitted: false,
};

const faqReducer = (state = initialState, action) => {
  switch (action.type) {
    case FAQ_LOADER_ACTIVE:
      return {
        ...state,
        faqLoader: action?.payload,
      };
    case FAQ_FORM_LOADER_ACTIVE:
      return {
        ...state,
        faqFormLoader: action?.payload,
      };
    case FAQ_FORM_SUBMITTED:
      return {
        ...state,
        formSubmitted: action?.payload,
      };
    case SET_FAQ_DATA: {
      return {
        ...state,
        faqData: action.payload,
      };
    }
    case SET_SINGLE_FAQ_DATA: {
      return {
        ...state,
        singleFaq: action.payload,
      };
    }
    case SET_FAQ_SECTION_DATA: {
      return {
        ...state,
        faqSectionData: action.payload,
      };
    }
    case DOWNLOAD_COUNT: {
      if (action.payload == "fileview") {
        return {
          ...state,
          singleFaq: {
            ...state.singleFaq,
            fileViewCount: (state.singleFaq?.fileViewCount || 0) + 1,
          },
        };
      } else
        return {
          ...state,
          singleFaq: {
            ...state.singleFaq,
            downloadCount: (state.singleFaq?.downloadCount || 0) + 1,
          },
        };
    }
    default:
      return state;
  }
};

export default faqReducer;
